export default __webpack_public_path__ + "static/h03-d6a9e4742807fb0e193a17e70101d210.png";